import moment from 'moment'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../common/html/element'
import { Loading } from '../../../../../../../common/loading'
import { Notification } from '../../../../../../../common/notification'
import { Table } from '../../../../../../../common/table'
import {
  selectChartHistoricalChange,
  selectHistoricalChangeTable,
  selectLoading,
} from '../../../../store/slice'

const HistoricalChangeTable = ({
  isDynamicReport,
  settingDynamic,
  timeFrequency,
}) => {
  const chartHistoricalChange = useSelector(selectChartHistoricalChange)
  const isLoading = useSelector(selectLoading('historicalChange'))

  const data = useMemo(() => {
    if (!chartHistoricalChange) return []
    return chartHistoricalChange.map((item) => ({
      ...item,
      colId: [item.intYear, item.intMonth, item.intQuarter].join('-'),
      title:
        timeFrequency === 'Yearly'
          ? String(item.intYear)
          : timeFrequency === 'Quarterly'
          ? `Q${item.intQuarter}-${item.intYear}`
          : timeFrequency === 'Monthly'
          ? moment(`${item.intMonth}/${item.intYear}`, 'MM/YYYY').format(
              isDynamicReport ? 'MM-YYYY' : 'MMM-YYYY',
            )
          : '',
    }))
  }, [chartHistoricalChange, timeFrequency])

  if (isLoading)
    return (
      <div className="positionRelative" style={{ height: 200 }}>
        <Loading />
      </div>
    )

  if (!data.length) return <Notification />

  return (
    <Element className="mt1">
      <Table
        ids={
          isDynamicReport
            ? mapKeysToValues(settingDynamic?.checkedHistoricalChange)
            : ['probabilityOfDefault', 'companyScore', 'modelSegmentScore']
        }
        getDataFromRedux={selectHistoricalChangeTable}
        schema={[
          {
            colId: 'indicator',
            title: 'corporateRiskScore.indicator',
            isI18n: true,
            render: (val) => <Translate value={val} />,
            tdStyle: { textAlign: 'left' },
            thStyle: {
              minWidth: 100,
            },
          },
          {
            colId: 'unit',
            title: 'corporateRiskScore.unit',
            isI18n: true,
            render: (val) => <Translate value={val} />,
            tdStyle: { textAlign: 'left' },
          },
          ...data.map((item) => ({
            colId: String(item.colId),
            title: String(item.title),
            thStyle: { justifyContent: 'flex-end' },
            tdStyle: { textAlign: 'right' },
          })),
        ]}
        noDataText="common.NO_DATA"
        autoHeightMax={400}
        isDynamicReport={isDynamicReport}
        isStickyFirstCol={true}
      />
    </Element>
  )
}

export default HistoricalChangeTable

const mapKeysToValues = (keys = []) => {
  const map = {
    data1: 'probabilityOfDefault',
    data2: 'companyScore',
    data3: 'modelSegmentScore',
  }
  return ['data1', 'data2', 'data3']
    .filter((k) => !keys.length || keys.includes(k))
    .map((k) => map[k])
}
